<template>
  <div class="px-8 md:px-0">
    <div class="static bg-white top-0 w-full z-10">

    <div class="w-full py-4 md:py-0 h-28 md:h-20 flex flex-col md:flex-wrap justify-end items-center border-b relative">
      <div class="flex flex-col md:flex-row items-start md:items-center px-3 lg:pr-10 justify-between w-full lg:w-7/12">
        <h4 class="text-yank mr-0 md:mr-3 lg:mr-0 mb-2 md:mb-0">All Scheduled Posts <span class="text-payneHot ">({{ $page.props.postsScheduledCount || 0 }})</span></h4>
      <button
        :disabled="pages.length > 0 ? disabled : ''"
        @click="$inertia.visit('/scheduler/posts/new')"
        class="static flex flex-wrap items-center border disabled:cursor-default disabled:bg-gray-200 border-softGray py-2 px-4 rounded-lg shadow-sm font-bold text-sm">
        <PlusIcon class="w-3 mr-2 text-payneHot"/>
        <span class="disabled:text-gray-300">Schedule Post</span> 
      </button>
      </div>
    </div>

    <div class="py-5 px-2 md:px-10 justify-between flex flex-wrap  flex-col sm:flex-row">
        <div class="flex flex-wrap items-center w-full lg:w-auto">
        
          <SearchInput @search="addFilter('search', $event)" input-classes="w-full md:w-auto bg-smoke h-10 " class="w-full md:w-auto mr-0 md:mr-4 text-sm mb-4 md:mb-0" />

          <FilterBadge
            v-for="(value, name) in shownFilters"
            :key="`filter-${name}-${value}`"
            :filter-val="value"
            :filter-name="name"
            class="mr-4"
            @remove="removeFilter(name)"
          />

          <div class="w-full md:w-auto flex md:block justify-between">
            <FiltersDropdown
                v-on:back="changeFilter('Filter by')"
                :title="filterTitle"
                :schedulerFilter="true"
                :active-filters="activeFilters"
                class="transition duration-300 ease-in-out rounded-full bg-payneHot text-white flex justify-center items-center font-medium px-5 h-10 border border-platinum focus:outline-none focus:border-yankFire focus:shadow-xl"
              >
                <template>
                  <PlusIcon class="h-4"/>
                  <span class="ml-3 font-normal">Filter</span>
                </template>
                <template slot="filters">  
                  <div class="text-sm">
                    <template v-if="filterType == 'Status'">
                      <StatusesFilter @change="onStatusFilterChange" :activeFilters="activeFilters" />
                    </template>

                    <template v-else-if="filterType === 'Schedule Date'">
                      <DateRangeFilter @change="onDateRangeFilterChange"/>
                    </template>

                    <template v-else-if="filterType == 'Accounts'">
                      <AccountFilter @change="onPagesFilterChange" :pages="pages"/>
                    </template>

                    <ul v-else class="px-4 py-2 text-sm">
                      <li @click="changeFilter('Status')" class="flex items-center py-2 cursor-pointer"><CheckFilter class="mr-3"/>Status</li>
                      <li @click="changeFilter('Schedule Date')" class="flex items-center py-2 cursor-pointer"><CalendarFilter class="mr-3"/>Schedule Date</li>
                      <li @click="changeFilter('Accounts')" class="flex items-center py-2 cursor-pointer"><AccountFilterIcon class="mr-3"/>Accounts</li>
                    </ul>  
                </div>   
              </template>
            </FiltersDropdown> 
            <inertia-link class="flex md:hidden items-center" :href="$route('social-settings.show', 'settings')">
              <span class="mr-2 text-sm text-gray-500">Schedule Settings</span>
              <Setting/>
            </inertia-link>
          </div>
       </div>
       <inertia-link class="hidden md:flex items-center" :href="$route('social-settings.show', 'settings')">
        <span class="mr-2 text-sm text-gray-500">Schedule Settings</span>
         <Setting/>
       </inertia-link>
      </div>

      <div class="hidden md:flex bg-smoke w-full bg-gray-500 text-xs py-5">
         <span  class="pl-12 text-payneFire w-4/12 uppercase text-xs tracking-widest font-semibold cursor-pointer">Post Date</span>
         <span  class="pl-2 text-payneFire w-3/12 uppercase text-xs tracking-widest font-semibold cursor-pointer ">Caption</span>
         <span  class="text-payneFire w-2/12 uppercase text-xs tracking-widest font-semibold cursor-pointer">Pages</span>
         <span  class="pl-2 text-payneFire w-3/12 uppercase text-xs tracking-widest font-semibold cursor-pointer">Status</span>       
      </div>
    </div>

    <div>
      <portal to="destination"> 
        <div v-show="removeModalOpen" class="flex justify-center items-center fixed z-20 bg-gray-500 bg-opacity-30 h-screen w-full">
          <ConfirmModal :postId="postId" :postDate="postDate" v-on:closeModal="closeConfirmModal" @delete="deletePost"/>
        </div>
      </portal>
      
      <div v-if="$page.props.posts.data.length > 0 && pages.length > 0" class="divide-y divide-smoke-500">
        <template v-for="post in allPosts">
          <TableRow v-on:confirmDelete="onConfirmDelete" :item="post" :key="post.id" :postId="post.id"/>  
        </template>

        <infinite-loading ref="infiniteLoader" @infinite="loadMore">
            <div slot="spinner" class="block">
              <row-skeleton v-for="item in 4" :key="`skeleton-item-${item}`"/>
            </div>
            <div slot="no-more" class="mt-8 text-sm font-medium text-payneFire">No more posts to display</div>
            <div slot="no-results" class="mt-8 text-sm font-medium text-payneFire">No more posts to display</div>
        </infinite-loading>
      </div>

      <div v-else class="flex h-96 flex-col items-center justify-center space-y-4 pt-40 md:pt-0">
        <NoAccountLinked/>
        <span v-if="pages.length > 0" class="text-customGray text-center font-semibold w-full md:w-4/12">Looks like you have no post created yet</span>
        <span v-if="pages.length == 0" class="text-customGray text-center font-semibold w-full md:w-4/12">Looks like you have no accounts linked yet</span>
        <inertia-link v-if="pages.length > 0" :href="$route('scheduler.posts.create')" class="flex bg-aquamarine text-white rounded-lg px-18 py-4">
          <span class="mr-2 ">Create a post</span>
          <BackArrow color="#FFFFFF" class="transform rotate-180"/>
        </inertia-link>
        <inertia-link  v-if="pages.length == 0" :href="$route('social-settings.show', 'settings')" class="flex bg-aquamarine text-white rounded-lg px-6 md:px-18 py-4">
          <span class="mr-2 ">Setup Social Media Channels</span>
          <BackArrow color="#FFFFFF" class="transform rotate-180"/>
        </inertia-link>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

import AppLayout from '@/layout/app-layout';

import SearchInput from "@/components/shared/SearchInput";
import FilterBadge from "@/components/shared/FilterBadge";
import FiltersDropdown from "@/components/shared/Common/FiltersDropdown";

import PlusIcon from "@/components/svg/PlusIcon";
import Setting from "@/components/svg/Setting";

import StatusesFilter from '@/components/scheduler/Filters/StatusesFilter';
import DateRangeFilter from '@/components/scheduler/Filters/DateRangeFilter';
import AccountFilter from '@/components/scheduler/Filters/AccountFilter';

import TableRow from '@/components/scheduler/Table/Row';
import TablePaginator from '@/components/scheduler/Table/Paginator';
import BackArrow from '@/components/svg/BackArrow';
import NoAccountLinked from '@/components/svg/NoAccountLinked';
import RowSkeleton from "@/components/shared/RowSkeleton";

import CheckFilter from '@/components/svg/CheckFilter';
import CalendarFilter from '@/components/svg/CalendarFilter';
import AccountFilterIcon from '@/components/svg/AccountFilterIcon';
import ConfirmModal from '@/components/scheduler/Common/ConfirmModal';

export default {
  name: 'SchedulerPosts',

  layout: AppLayout,

  props: {
    posts: Object,

    filters: Object,

    accounts: {
      type:Array,
      required:true
    },
    pages:{
      type:Array,
      require:true
    },
    accountFilters: {
      type:Array,
      require:true
    },

    flash:{
      type:Object,
      required:true
    } ,
  },

  components: {
    SearchInput,
    FilterBadge,
    PlusIcon,
    TableRow,
    TablePaginator,
    Setting,
    FiltersDropdown,
    StatusesFilter,
    DateRangeFilter,
    CheckFilter,
    CalendarFilter,
    AccountFilterIcon,
    ConfirmModal,
    NoAccountLinked,
    BackArrow,
    AccountFilter,
    InfiniteLoading,
    RowSkeleton
  },

  data() {
    return {
      activeFilters: this.filters || {},
      allPosts: this.posts.data,
      filterType: '',
      filterTitle:'Filter by',
      removeModalOpen:false,
      postId:'',
      postDate:'',
      filters: {
        type: null,
      }
    }
  },

  methods: {
    loadMore($state) {
      if (!this.posts.next_page_url) {
        return
      }

      this.$inertia.visit(this.posts.next_page_url, {
        preserveState: true,
        preserveScroll: true,
        only: ['posts'],
        onFinish: () => {
          $state.loaded()
          if (!this.posts.next_page_url) {
            $state.complete()
          }
        }
      })
    },

    visitPage: function(pageUrl) {
      if(pageUrl !== null) {
        this.$inertia.visit(pageUrl, this.parsedFilters, {
          preserveState: true,
        });
      }
    },

    onStatusFilterChange: function(filters) {
      for (const [key, value] of Object.entries(filters)) {
        this.removeFilter(key);
        if(value)
          this.addFilter(key, value);
      }
    },

    onDateRangeFilterChange: function(data) {
      this.removeFilters(['day', 'month', 'year', 'range']);
      this.addFilter(data.filter, data.value);
    },

    onPagesFilterChange: function(data){
      this.addFilter('account', data);
    },

    changeFilter(filter){
      this.filterType = filter;
      this.filterTitle = filter;
    },

    addFilter(type, value) {
      this.$set(this.activeFilters, type, value);
      this.runSearch();
    },

    removeFilter(type) {
      delete this.activeFilters[type];
      this.runSearch();
    },

    removeFilters(filters) {
      filters.forEach((filter) => {
        delete this.activeFilters[filter];
      });
    },

    clearFilters() {
      this.activeFilters = {};
      this.runSearch();
    },

    runSearch() {
      this.$inertia.get(this.$route('scheduler.posts.index'), this.parsedFilters, {
        onStart: (visit) => this.working = true,
        onFinish: (visit) => this.working = false,
        preserveScroll: true,
      })
    },

    onConfirmDelete(item) {
      this.postId = item.id
      this.postDate = item.postDate
      this.removeModalOpen = true
    },

    closeConfirmModal(){
      this.removeModalOpen = false
    },

    getPagesNames(pages) {
      let message = '';
      pages.forEach(pageId => {
        let page = this.pages.filter(page => page.id == pageId);
        let name = JSON.parse(page[0].metadata)['name'];
        if(message === '') {
          message = `${name}`;
        } else {
          message = `${message}, ${name}`;
        }
      })
      return message;
    },

    deletePost(postId) {
      this.deletingPost = true;
      this.clearFilters();
      this.$inertia
        .delete(this.$route("scheduler.posts.destroy", { postId: postId }))
        .then(() => {
          this.allPosts.splice(
            this.allPosts.findIndex(post => post.id === postId),
            1
          );
        });
      this.allPosts = this.post.data;
      this.deletingPost = false;
    }
  },

  mounted: function() {
    if (this.flash.success && this.flash.success !== '') {
      this.$toast.success(this.flash.success);
    }

    if (this.flash.error && this.flash.error !== '') {
      this.$toast.error(this.flash.error);
    }

    if (!this.posts.next_page_url) {
      this.$refs.infiniteLoader.stateChanger.loaded()
      this.$refs.infiniteLoader.stateChanger.complete()
    }
  },

  computed: {
    parsedFilters() {
      const filters = {};

      Object.keys(this.activeFilters).forEach(key => {
        if (this.activeFilters[key] === null) {
          delete this.activeFilters[key];
          return;
        }

        let keyName = `filter[${key}]`;
        filters[keyName] = this.activeFilters[key];
      });

      return filters;
    },

    shownFilters() {
      let shownFilters = {...this.activeFilters};
      if(shownFilters.account) {
        let pagesNames = this.getPagesNames(shownFilters.account);
        shownFilters.account = pagesNames;
      }

      return shownFilters;
    }
  },

    watch: {
      flash: {
        handler(flash) {
          if (flash.success && flash.success !== '') {
            this.$toast.success(flash.success);
          }
          if (flash.error && flash.error !== '') {
           this.$toast.error(flash.error);
          }
        },
        deep: true,
      },

      posts(posts) {
      if (!this.deletingPost) {
        this.allPosts.push(...posts.data);
      }
    }
    },
}
</script>